module.exports = __webpack_public_path__ + "static/img/zhenshuang.5c843b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/market/zhenshuang.png
// module id = 45ek
// module chunks = 2